/* SordyDog — scripts propios. Todo vanilla, sin librerías. */
(function () {
  'use strict';
  // Cada sección incluye este archivo: que solo se ejecute una vez por página
  if (window.__sdScriptsListo) return;
  window.__sdScriptsListo = true;

  var sdObs = null;
  function mostrarVisibles() {
    // Red de seguridad: lo que ya está en pantalla se muestra aunque el observador no haya saltado
    var h = window.innerHeight || 800;
    document.querySelectorAll('.sd-reveal:not(.sd-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.95 && r.bottom > 0) el.classList.add('sd-visible');
    });
  }
  function initReveal() {
    var els = document.querySelectorAll('.sd-reveal:not(.sd-visible)');
    if (!els.length) return;
    var sinAnimar = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
                    !('IntersectionObserver' in window);
    if (sinAnimar) {
      els.forEach(function (el) { el.classList.add('sd-visible'); });
      return;
    }
    if (!sdObs) {
      sdObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('sd-visible'); sdObs.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    els.forEach(function (el) {
      if (el.dataset.sdObs === '1') return;
      el.dataset.sdObs = '1';
      sdObs.observe(el);
    });
    mostrarVisibles();
  }

  function initFaq() {
    var items = document.querySelectorAll('.sd-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.sd-faq__q');
      var a = item.querySelector('.sd-faq__a');
      if (!q || !a || item.dataset.sdListo === '1') return;
      item.dataset.sdListo = '1';
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var open = item.classList.contains('sd-open');
        item.classList.toggle('sd-open', !open);
        q.setAttribute('aria-expanded', String(!open));
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
      });
    });
  }

  function initGaleria() {
    var wrap = document.querySelector('[data-sd-galeria]');
    if (!wrap || wrap.dataset.sdListo === '1') return;
    wrap.dataset.sdListo = '1';
    var main = wrap.querySelector('[data-sd-galeria-main]');
    var thumbs = wrap.querySelectorAll('[data-sd-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src) main.setAttribute('src', src);
        thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        if (t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
        }
      });
    });

    // Deslizar con el dedo sobre la foto grande = foto siguiente / anterior
    var x0 = null, y0 = null;
    main.parentNode.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    main.parentNode.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var lista = Array.prototype.slice.call(thumbs);
      var i = lista.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      var j = (i + (dx < 0 ? 1 : -1) + lista.length) % lista.length;
      lista[j].click();
    }, { passive: true });
  }

  function initVariantes() {
    var root = document.querySelector('[data-sd-producto]');
    if (!root || root.dataset.sdListo === '1') return;
    root.dataset.sdListo = '1';
    var dataEl = root.querySelector('[data-sd-variantes]');
    if (!dataEl) return;

    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var idInput = root.querySelector('[data-sd-variant-id]');
    var boton = root.querySelector('[data-sd-add]');
    var precioNow = root.querySelector('[data-sd-precio]');
    var precioWas = root.querySelector('[data-sd-precio-antes]');
    var grupos = root.querySelectorAll('[data-sd-opcion]');
    if (!grupos.length) return;

    function seleccion() {
      return Array.prototype.map.call(grupos, function (g) {
        var sel = g.querySelector('[aria-checked="true"]');
        return sel ? sel.getAttribute('data-valor') : null;
      });
    }

    function dinero(centimos) {
      var n = (centimos / 100).toFixed(2).replace('.', ',');
      return n + ' €';
    }

    function actualizar() {
      var elegido = seleccion();
      var v = null;
      for (var i = 0; i < variantes.length; i++) {
        var ok = true;
        for (var j = 0; j < elegido.length; j++) {
          if (elegido[j] !== null && variantes[i].options[j] !== elegido[j]) { ok = false; break; }
        }
        if (ok) { v = variantes[i]; break; }
      }
      if (!v) {
        if (boton) { boton.setAttribute('disabled', 'disabled'); boton.textContent = 'Combinación no disponible'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (precioNow) precioNow.textContent = dinero(v.price);
      if (precioWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          precioWas.textContent = dinero(v.compare_at_price);
          precioWas.style.display = '';
        } else {
          precioWas.style.display = 'none';
        }
      }
      if (boton) {
        if (v.available) {
          boton.removeAttribute('disabled');
          boton.textContent = boton.getAttribute('data-texto') || 'Añadir al carrito';
        } else {
          boton.setAttribute('disabled', 'disabled');
          boton.textContent = 'Agotado';
        }
      }
    }

    grupos.forEach(function (g) {
      g.querySelectorAll('[data-valor]').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('[data-valor]').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
          b.setAttribute('aria-checked', 'true');
          actualizar();
        });
      });
    });

    actualizar();
  }

  // Selector de packs: cambia la cantidad que se añade al carrito
  function initPacks() {
    var cont = document.querySelector('[data-sd-packs]');
    var campo = document.querySelector('[data-sd-cantidad]');
    if (!cont || !campo || cont.dataset.sdListo === '1') return;
    cont.dataset.sdListo = '1';
    cont.querySelectorAll('[data-sd-pack]').forEach(function (b) {
      b.addEventListener('click', function () {
        cont.querySelectorAll('[data-sd-pack]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        campo.value = b.getAttribute('data-sd-pack') || '1';
      });
    });
    var activo = cont.querySelector('[aria-pressed="true"]');
    if (activo) campo.value = activo.getAttribute('data-sd-pack') || '1';
  }

  // Barra fija de compra: aparece cuando el botón principal ya ha quedado arriba
  function initBarraCompra() {
    var root = document.querySelector('[data-sd-producto]');
    var bar = document.querySelector('[data-sd-stick]');
    if (!root || !bar || bar.dataset.sdListo === '1') return;
    bar.dataset.sdListo = '1';
    var mainBtn = root.querySelector('[data-sd-add]');
    var form = mainBtn && mainBtn.closest('form');
    if (!mainBtn || !form) return;
    var modo = bar.classList.contains('sd-stick--siempre') ? 'siempre' : 'movil';
    document.body.classList.add('sd-stick-pad-' + modo);

    var precioMain = root.querySelector('[data-sd-precio]');
    var precioBar = bar.querySelector('[data-sd-stick-precio]');
    var btnBar = bar.querySelector('[data-sd-stick-add]');

    function sync() {
      if (precioMain && precioBar) precioBar.textContent = precioMain.textContent;
      bar.querySelectorAll('[data-sd-stick-opcion]').forEach(function (g) {
        var grupo = root.querySelector('[data-sd-opcion][data-indice="' + g.getAttribute('data-sd-stick-opcion') + '"]');
        var sel = grupo && grupo.querySelector('[aria-checked="true"]');
        var val = sel ? sel.getAttribute('data-valor') : null;
        g.querySelectorAll('[data-valor]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-valor') === val));
        });
      });
      if (btnBar) btnBar.disabled = mainBtn.disabled;
    }

    bar.querySelectorAll('[data-sd-stick-opcion] [data-valor]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.parentNode.getAttribute('data-sd-stick-opcion');
        var destino = root.querySelector('[data-sd-opcion][data-indice="' + i + '"] [data-valor="' + CSS.escape(b.getAttribute('data-valor')) + '"]');
        if (destino) destino.click();
        sync();
      });
    });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-sd-opcion]')) setTimeout(sync, 0); });
    if (btnBar) btnBar.addEventListener('click', function () { if (!mainBtn.disabled) mainBtn.click(); });

    function mostrar(si) {
      bar.classList.toggle('sd-on', si);
      bar.setAttribute('aria-hidden', String(!si));
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = si ? 0 : -1; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        mostrar(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(form);
    }
    sync();
  }

  function initMarquesina() {
    document.querySelectorAll('[data-sd-marquesina]').forEach(function (track) {
      if (track.dataset.sdClonado === '1') return;
      track.innerHTML += track.innerHTML;
      track.dataset.sdClonado = '1';
      var seg = track.getAttribute('data-velocidad') || '30';
      track.style.animationDuration = seg + 's';
    });
  }

  function initParallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-sd-parallax]'));
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var grande = window.matchMedia('(min-width: 990px)');
    var pendiente = false;
    function pinta() {
      pendiente = false;
      (window.__sdParallaxEls || els).forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-sd-parallax')) || 0;
        if (!grande.matches || !k) { el.style.transform = ''; return; }
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var y = Math.max(-r.top, 0) * (k / 100);
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
    }
    function pide() { if (!pendiente) { pendiente = true; window.requestAnimationFrame(pinta); } }
    if (!window.__sdParallax) {
      window.addEventListener('scroll', pide, { passive: true });
      window.addEventListener('resize', pide);
      window.__sdParallax = true;
    }
    window.__sdParallaxEls = els;
    pinta();
  }

  function start() {
    initParallax();
    initReveal();
    initFaq();
    initGaleria();
    initVariantes();
    initPacks();
    initBarraCompra();
    initMarquesina();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Cuando terminan de cargar estilos e imágenes, se repasa (todo es idempotente)
  window.addEventListener('load', function () { initReveal(); mostrarVisibles(); });
  window.addEventListener('scroll', function () { if (!window.__sdRevScroll) { window.__sdRevScroll = true; requestAnimationFrame(function () { window.__sdRevScroll = false; mostrarVisibles(); }); } }, { passive: true });
  setTimeout(mostrarVisibles, 1500);
  document.addEventListener('shopify:section:load', start);
})();
